var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-medium flex-shrink-0",attrs:{"small":"","label":"","color":"success"}},[_vm._v(" DONE! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }